import { useEffect, useRef, useState } from "react";
import tataAiaLogo from "@/assets/tata-aia-logo.png";
import { RateRow } from "./types";
import Card from "./Card";
import PremiumCard from "./PremiumCard";
import EligibilityCard from "./EligibilityCard";
import HabitsCard from "./HabitsCard";
import FamilyHistoryCard from "./FamilyHistoryCard";
import AntiCapture from 'react-anticapture';
import { API_CONFIG, API_ENDPOINTS } from "../../apis/config";
// @ts-ignore: missing type declarations for apimethod.js
import { decryptData } from "../../Services/req_res_decode_encode.js";
import LOGOUrl from "@/assets/images/logo1.png";
import PremiumLogo from "@/assets/images/headercard.png";
import Healthy from "@/assets/images/hb.png";
import Videos from "./Videos.js";
import { useNavigate } from "react-router-dom";
import PopupModal from "../ui/Popup.js";
import OnePager from "@/assets/images/launchedm.jpg";
// @ts-ignore: missing type declarations for apimethod.js
import PDFViewer from "./PdfViewer.js";
import { pdfjs } from 'react-pdf';
// @ts-ignore: missing type declarations for apimethod.js
import { API } from "../../Services/apimethod.js"

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.mjs',
  import.meta.url,
).toString();

export default function CancerCareTool() {
  const navigate = useNavigate();
  const [open, setOpen] = useState<Record<string, boolean>>({});
  const [rateTable, setRateTable] = useState<RateRow[]>([]);
  const [adminData, setAdminData] = useState<any>(null);
  const [hidden, setHidden] = useState(false);
  const [openItem, setOpenItem] = useState<boolean>(false);
  const [openOnePager, setOpenOnePager] = useState<boolean>(false);
  const containerRef = useRef<HTMLDivElement>(null);
  const [selectedItem, setSelectedItem] = useState<string>("");

  useEffect(() => {
    const handleVisibility = () => {
      setHidden(document.hidden);
    };
    document.addEventListener("visibilitychange", handleVisibility);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibility);
    };
  }, []);


  // DYNAMIC LOGO
  const [logoUrl, setLogoUrl] = useState(tataAiaLogo);

  // STATIC FALLBACK DATA
  const staticAdminData = {
    leftBadge: "Quick Assessment",
    title: "Check what fits your life",
    subtitle:
      "Tap any card to expand and use the tool. Your inputs stay on this device.",
    rightBadge: "All checks run instantly · 100% private",
    badgeText: "DISCLAIMER",
    disclaimerPoints: [
      "The eligible Sum Assured indicated herein is basis the declared income range and may vary subject to actual income declared at proposal stage.",

      "Cancer Care benefit may be offered as a standalone policy or as a rider with any other product. For detailed underwriting criteria, please refer to the Underwriting Guidelines for Cancer Care benefit.",
    ],
  };

  const data = adminData || staticAdminData;
  useEffect(() => {
    import("@/data/rateTable.json").then((m) => {
      setRateTable((m.default ?? m) as RateRow[]);
    });
  }, []);

  // TOOLTIP
  useEffect(() => {
    const tips = document.querySelectorAll(".cc-tip");

    const tooltip = document.createElement("div");

    tooltip.id = "global-tooltip";

    Object.assign(tooltip.style, {
      position: "fixed",
      zIndex: "99999",
      maxWidth: "260px",
      background: "#1e293b",
      color: "#fff",
      padding: "10px 12px",
      borderRadius: "8px",
      fontSize: "11px",
      lineHeight: "1.5",
      boxShadow: "0 4px 16px rgba(0,0,0,.35)",
      pointerEvents: "none",
      fontFamily: "Arial, sans-serif",
      fontWeight: "400",
      display: "none",
      whiteSpace: "normal",
      wordWrap: "break-word",
    });

    document.body.appendChild(tooltip);

    tips.forEach((tip) => {
      tip.addEventListener("mouseenter", () => {
        tooltip.innerText = tip.getAttribute("data-tip") || "";
        tooltip.style.display = "block";

        const rect = tip.getBoundingClientRect();

        let left = rect.right + 8;
        let top = rect.top - 4;

        if (left + 270 > window.innerWidth) {
          left = rect.left - 270;
        }

        tooltip.style.left = left + "px";
        tooltip.style.top = top + "px";
      });

      tip.addEventListener("mouseleave", () => {
        tooltip.style.display = "none";
      });
    });

    return () => {
      if (document.body.contains(tooltip)) {
        document.body.removeChild(tooltip);
      }
    };
  }, [open]);

  const toggle = (id: string) =>
    setOpen((o) => ({
      ...o,
      [id]: !o[id],
    }));

  return (

    <div className={`cc-root ${hidden ? "blurred" : ""}`}
    onContextMenu={(e) => e.preventDefault()}
    onCopy={(e) => e.preventDefault()}
    onCut={(e) => e.preventDefault()}
    onDragStart={(e) => e.preventDefault()}
    style={{ userSelect: "none" }}
    >
      {/* HEADER */}
      <div className="header">
        <img
          src="https://www.freelogovectors.net/wp-content/uploads/2021/01/tata-aia-life-logo-freelogovectors.net_.png"
          alt="TATA AIA Logo"
        />

        <div className="header-actions">
          <select className="lang-select" defaultValue="🌐 Choose Language">
            <option value="🌐 Choose Language">
              🌐 Choose Language
            </option>

            <option value="Hindi">Hindi</option>
            <option value="Marathi">Marathi</option>
            <option value="Tamil">Tamil</option>
            <option value="Gujarati">Gujarati</option>
            <option value="Telugu">Telugu</option>
            <option value="Bengali">Bengali</option>
            <option value="Kannada">Kannada</option>
          </select>
        </div>
      </div>
      <div className="cc-page-new">
        <div className="mobile-logo-wrap">
          <div className="mobile-logo-row">
            <img
              src={LOGOUrl}
              alt="Cancer Care Logo"
              className="mobile-logo"
            />
          </div>

          <a
            href="https://m365.cloud.microsoft/chat/?titleId=T_2557bf26-e453-0d21-9a75-62085f245a8a&source=embedded-builder"
            target="_blank"
            rel="noopener noreferrer"
            className="copilot-search"
          >
            🔍 Ask Me Anything About Cancer Care...
          </a>
        </div>
      </div>
      <div className="main-video cc-page-new">
        <Videos />
      </div>
      <div className="premium-header-card cc-page-new" style={{ paddingBottom: "0px" }}>
        <img
          src={PremiumLogo}
          alt="Calculate Premium & Check Eligibility"
        />
      </div>


      {/* CARDS */}
      <div className="cc-page-new">
        <div className="cc-cards-grid">


          <Card
            id="card1"
            color="blue"
            icon="💰"
            title="Calculate Premium"
            subtitle="Estimate annualised premium"
            open={!!open.card1}
            onToggle={() => toggle("card1")}
          >
            <PremiumCard />
          </Card>
            <Card
            id="card2"
            color="green"
            icon="🎓"
            title="Education / Occupation / Income"
            subtitle="Check eligible sum assured"
            open={!!open.card2}
            onToggle={() => toggle("card2")}
          >
            <EligibilityCard />
          </Card>
          <Card
            id="card3"
            color="amber"
            icon="🚬"
            title="Habits"
            subtitle="Check lifestyle eligibility"
            open={!!open.card3}
            onToggle={() => toggle("card3")}
          >
            <HabitsCard />
          </Card>

          <Card
            id="card4"
            color="purple"
            icon="🧬"
            title="Personal/Family History"
            subtitle="Check eligibility basis Personal & Family history"
            open={!!open.card4}
            onToggle={() => toggle("card4")}
          >
            <FamilyHistoryCard />
          </Card>
        </div>

        <div className="toolkit-section">
          <h2 className="toolkit-title">Sales Toolkit</h2>
          <div className="toolkit-grid">
            <a
              className="toolkit-tile"
              style={{ cursor: "pointer" }}
              onClick={() => navigate("/generate-bi")}
            >
              <span className="toolkit-icon">💬</span>
              Generate BI
            </a>

            <a
              className="toolkit-tile"
              style={{ cursor: "pointer" }}
              onClick={() => navigate("/key-benefits")}
            >
              <span className="toolkit-icon">🎯</span>
              Product Benefits
            </a>
            <a
              className="toolkit-tile"
              style={{ cursor: "pointer" }}
              onClick={() => navigate("/evaluate-persona")}
            >
              <span className="toolkit-icon">👤</span>
              Persona Based Pitching
            </a>
            <a className="toolkit-tile toolkit-disabled">
              <span className="coming-badge">Coming Soon</span>
              <span className="toolkit-icon">🛡️</span>
              Objection Handling
            </a>
            <a className="toolkit-tile toolkit-disabled">
              <span className="coming-badge">Coming Soon</span>
              <span className="toolkit-icon">📄</span>
              All About Claims
            </a>
            <a className="toolkit-tile toolkit-disabled">
              <span className="coming-badge">Coming Soon</span>
              <span className="toolkit-icon">
                <img src={Healthy} alt="Health Buddy" />
              </span>
              Health Buddy
            </a>
            <a className="toolkit-tile toolkit-disabled">
              <span className="coming-badge">Coming Soon</span>
              <span className="toolkit-icon">📚</span>
              Ready Reckoner
            </a>
            <a className="toolkit-tile toolkit-disabled">
              <span className="coming-badge">Coming Soon</span>
              <span className="toolkit-icon">📝</span>
              VCoach
            </a>
          </div>
        </div>


        {/* Sales Kit */}
        <div className="downloads-section">
          <h2 className="downloads-title">Sales Kit</h2>
          <div className="downloads-grid">
            <a
              href="#"
              className="folder-card"
              onClick={() =>
                setOpenItem(true)
                // window.open("pages/Cancer Care - May 2026.pdf", "_blank")
              }
            >
              <div className="folder-icon">📁</div>
              <div className="folder-name">Decks</div>
            </a>
            <a
              style={{ cursor: "pointer" }}
              onClick={() => setOpenOnePager(true)}
              rel="noopener noreferrer"
              className="folder-card"
            >
              <div className="folder-icon">📄</div>
              <div className="folder-name"
              >One Pagers</div>
            </a>
          </div>
        </div>


        {/* DISCLAIMER */}
        <div className="disclaimer-box">
          <div className="disclaimer-title">DISCLAIMER</div>
          <ul>
            <li>
              The eligible Sum Assured indicated herein is basis the declared
              income range and may vary subject to actual income declared at
              proposal stage.
            </li>
            <li>
              Additional documents may be requested during claim assessment.
              Please refer to the sales brochure and policy document for more
              details.
            </li>
            <li>
              Premiums shown above are excluding add-ons and discounts.
            </li>
            <li>
              Cancer Care benefit may be offered as a standalone policy or as a
              rider with any other product. For detailed underwriting criteria,
              please refer to the Underwriting Guidelines for Cancer Care benefit.
            </li>
            <li>
              This tool does not guarantee the issuance of Cancer Care benefit of
              the assessed life; final decision would be subject to underwriting.
            </li>
          </ul>
        </div>
      </div>
               <PopupModal
                isOpen={openItem}
                setOpen={setOpenItem}
                title="CancerCareDeck"
            >
              <PDFViewer  />
               {/* <div ref={containerRef} className="pdf-h"></div> */}
            </PopupModal>

            <PopupModal
                isOpen={openOnePager}
                setOpen={setOpenOnePager}
                title="OnePager"
            >
              <img src={OnePager} alt="Cancer Care Deck" className="onepager-container-image" />
            </PopupModal>
    </div>
  );
}
 